export const EP_AREAS_LIST = 'private.dashboard.areas.list';
export const EP_AREA_GET_BY_ID = 'private.dashboard.areas.getById';
export const EP_AREAS_UPDATE = 'private.dashboard.areas.update';
export const EP_AREAS_BULK_UPDATE_CSV = 'private.dashboard.areas.bulkUpdateCsv';

export const EP_DELIVERIES_LIST_ACTIVE = 'private.dashboard.deliveries.active.list';
export const EP_DELIVERIES_LIST_HISTORY = 'private.dashboard.deliveries.history.list';
export const EP_DELIVERIES_DRIVERS_LIST = 'private.dashboard.deliveries.drivers.list';
export const EP_DELIVERIES_STORES_LIST = 'private.dashboard.deliveries.stores.list';
export const EP_DELIVERIES_GET_DRIVER_DETAILS = 'private.dashboard.deliveries.active.getDriverDetails';
export const EP_DELIVERIES_UPDATE_DELIVERY_DRIVER = 'private.dashboard.deliveries.active.updateDriver';
export const EP_DELIVERIES_GET_BY_ID = 'private.dashboard.deliveries.getById';
export const EP_DELIVERIES_DELIVERY_LOCATION = 'private.dashboard.deliveries.location.getById';

export const EP_DRIVERS_LIST = 'private.dashboard.drivers.list';
export const EP_DRIVER_GET_BY_ID = 'private.dashboard.drivers.getById';
export const EP_DRIVERS_UPDATE = 'private.dashboard.drivers.update';
export const EP_DRIVERS_CREATE = 'private.dashboard.drivers.create';
export const EP_DRIVERS_REMOVE = 'private.dashboard.drivers.delete';
export const EP_DRIVERS_REMOVE_ACTIVE_DELIVERY = 'private.dashboard.drivers.removeActiveDelivery';
export const EP_DRIVERS_REQUEST_LOCATION = 'private.dashboard.drivers.requestLocation';

export const EP_DRIVERS_DETAILS = 'private.dashboard.drivers.details';

export const EP_FLEET_PERFORMANCE_REPORT = 'private.dashboard.fleet.performanceReport.get';
export const EP_FLEET_PERFORMANCE_REPORT_CHARTS = 'private.dashboard.fleet.performanceReport.charts';
export const EP_FLEET_PERFORMANCE_REPORT_EXPORT = 'private.dashboard.fleet.performanceReport.export';
export const EP_FLEET_PERFORMANCE_TREND = 'private.dashboard.fleet.performanceTrend';

export const EP_CATEGORIES_GET_BY_ID = 'private.dashboard.categories.getById';
export const EP_CATEGORIES_DELETE = 'private.dashboard.categories.delete';
export const EP_CATEGORIES_UPDATE = 'private.dashboard.categories.edit';
export const EP_CATEGORIES_LIST = 'private.dashboard.categories.list';
export const EP_CATEGORIES_SORT = 'private.dashboard.categories.sort';
export const EP_CATEGORIES_UPLOAD_PARTNER_IMAGE = 'private.dashboard.categories.uploadPartnerImage';
export const EP_CATEGORIES_CREATE = 'private.dashboard.categories.create';
export const EP_CATEGORIES_DETAIL = 'private.dashboard.category.details';
export const EP_CATEGORY_UPDATE = 'private.dashboard.categories.update';
export const EP_CATEGORY_REMOVE_SUBCATEGORY = 'private.dashboard.categories.removeSubcategory';
export const EP_CATEGORIES_SYNC = 'private.dashboard.categories.sync';
export const EP_CATEGORIES_SYNC_GET_LAST_UPDATE = 'private.dashboard.categories.sync.getLastUpdate';

export const EP_SUBCATEGORY_LIST = 'private.dashboard.subcategories.list';
export const EP_SUBCATEGORY_CREATE = 'private.dashboard.subcategories.create';
export const EP_SUBCATEGORY_UPDATE = 'private.dashboard.subcategories.update';
export const EP_SUBCATEGORY_SORT = 'private.dashboard.subcategories.sort';
export const EP_SUBCATEGORY_SEARCH = 'private.dashboard.subcategories.search';
export const EP_LINK_SUBCATEGORY = 'private.dashboard.categories.addSubcategory';
export const EP_PRODUCTS_BY_SUBCATEGORY = 'private.dashboard.subcategories.products.list';
export const EP_SORT_SUBCATEGORY_PRODUCTS = 'private.dashboard.subcategories.products.sort';
export const EP_SUBCATEGORY_REMOVE_PRODUCT = 'private.dashboard.subcategories.products.remove';
export const EP_SUBCATEGORY_ADD_PRODUCT = 'private.dashboard.subcategories.products.add';
export const EP_SUBCATEGORY_PRODUCT_SEARCH = 'private.dashboard.products.search';
export const EP_SUBCATEGORY_DETAIL = 'private.dashboard.subcategories.details';

export const EP_FEATURED_CATEGORIES_LIST = 'private.dashboard.featuredCategories.list';
export const EP_FEATURED_CATEGORY_DETAILS = 'private.dashboard.featuredCategories.details';
export const EP_FEATURED_CATEGORY_CREATE_UPDATE = 'private.dashboard.featuredCategories.create';
export const EP_FEATURED_CATEGORY_UPDATE_DISCOUNT = 'private.dashboard.featuredCategories.updateDiscount';
export const EP_FEATURED_CATEGORY_GET_PRODUCTS_BY_SUBCATEGORY = 'private.dashboard.featuredCategories.productsBySubcategory';
export const EP_FEATURED_CATEGORY_UPDATE_SUBCATEGORY_PRODUCTS = 'private.dashboard.featuredCategories.addSubcategoryProducts';
export const EP_FEATURED_CATEGORY_UPLOAD_PRODUCT_BARCODES = 'private.dashboard.featuredCategories.uploadProductBarcodes';
export const EP_FEATURED_CATEGORY_UPDATE_CUSTOMER_SEGMENT = 'private.dashboard.featuredCategories.updateCustomerSegment';
export const EP_FEATURED_CATEGORY_UPDATE_LIMITS_AND_RESTRICTIONS = 'private.dashboard.featuredCategories.updateLimitsAndRestrictions';
export const EP_FEATURED_CATEGORY_UPDATE_DISPLAY_OPTIONS = 'private.dashboard.featuredCategories.updateDisplayOptions';
export const EP_FEATURED_CATEGORY_UPDATE_STATUS = 'private.dashboard.featuredCategories.updateStatus';
export const EP_FEATURED_CATEGORY_PERSONALIZED_UPLOAD_PRODUCTS = 'private.dashboard.featuredCategories.personalized.uploadProducts';
export const EP_FEATURED_CATEGORY_PERSONALIZED_DOWNLOAD_PRODUCTS = 'private.dashboard.featuredCategories.personalized.downloadProducts';
export const EP_FEATURED_CATEGORY_WIDGET_SORT_ORDER = 'private.dashboard.featuredCategories.getWidgetSortOrder';
export const EP_FEATURED_CATEGORY_SORT_WIDGETS = 'private.dashboard.featuredCategories.sortWidgets';

export const EP_SIGN_IN = 'private.dashboard.users.signIn';

export const EP_COLLECTION = 'private.dashboard.collections';
export const EP_COLLECTION_GET_BY_ID = 'private.dashboard.collections.getById';
export const EP_COLLECTION_UPDATE = 'private.dashboard.collections.edit';
export const EP_COLLECTION_DELETE = 'private.dashboard.collections.delete';

export const EP_COLLECTION_IMAGE_UPLOAD = 'private.dashboard.collections.uploadImage';

export const EP_BANNER_LIST = 'private.dashboard.banners.list';
export const EP_BANNER_SORT = 'private.dashboard.banners.sort';
export const EP_BANNER_DELETE = 'private.dashboard.banners.delete';
export const EP_BANNER_IMAGE_UPLOAD = 'private.dashboard.banners.uploadImage';
export const EP_BANNER_GET_BY_ID = 'private.dashboard.banners.getById';
export const EP_BANNERS_CREATE = 'private.dashboard.banners.create';
export const EP_BANNERS_UPDATE = 'private.dashboard.banners.edit';

export const EP_NOTIFICATION_LIST = 'private.dashboard.notifications.list';
export const EP_NOTIFICATION_UPDATE_STATUS = 'private.dashboard.notifications.updateStatus';
export const EP_NOTIFICATION_GET_BY_ID = 'private.dashboard.notifications.getById';
export const EP_NOTIFICATIONS_CREATE = 'private.dashboard.notifications.create';
export const EP_NOTIFICATIONS_UPDATE = 'private.dashboard.notifications.update';
export const EP_NOTIFICATIONS_CUSTOMER_SEGMENT_LIST = 'private.dashboard.notifications.segments.list';
export const EP_NOTIFICATIONS_CUSTOMERS_REACH = 'private.dashboard.notifications.getCustomersReach';
export const EP_NOTIFICATIONS_FEATUREDCATEGORIES_LIST = 'private.dashboard.notifications.featuredCategories.list';
export const EP_NOTIFICATION_ACTIVATE = 'private.dashboard.notifications.activate';
export const EP_NOTIFICATION_CANCEL = 'private.dashboard.notifications.cancel';
export const EP_NOTIFICATION_GET_LOGS = 'private.dashboard.notifications.logs.list';
export const EP_NOTIFICATION_RETRY_DLQ = 'private.dashboard.notifications.retry.dlq';
export const EP_NOTIFICATION_TEMPLATES_SENDGRID_LIST = 'private.dashboard.notifications.templates.sendgrid.list';
export const EP_NOTIFICATION_TEMPLATES_TWILIO_LIST = 'private.dashboard.notifications.templates.twilio.list';
export const EP_NOTIFICATION_TEMPLATES_WHATSAPP_CLOUD_LIST = 'private.dashboard.notifications.templates.whatsappCloud.list';
export const EP_NOTIFICATION_TEST_PUSH = 'private.dashboard.notifications.test.push';

export const EP_STORES_LIST = 'private.dashboard.stores.list';
export const EP_STORES_GET_BY_ID = 'private.dashboard.stores.getById';
export const EP_STORES_UPDATE = 'private.dashboard.stores.update';
export const EP_STORES_GET_DELIVEROO_SETTINGS = 'private.dashboard.stores.getDeliverooSettings';
export const EP_STORES_GET_DELIVEROO_SERVICE_HOURS = 'private.dashboard.stores.getDeliverooServiceHours';
export const EP_STORES_GET_DELIVEROO_STATUS = 'private.dashboard.stores.getDeliverooStatus';
export const EP_STORES_UPDATE_DELIVEROO_SERVICE_HOURS = 'private.dashboard.stores.update.deliverooServiceHours';
export const EP_STORES_UPDATE_DELIVEROO_STATUS = 'private.dashboard.stores.update.deliverooStatus';
export const EP_STORES_UPDATE_DELIVEROO_SITE = 'private.dashboard.stores.update.deliverooSite';
export const EP_SETTINGS_GET_DELIVEROO = 'private.dashboard.settings.deliveroo.get';
export const EP_SETTINGS_UPDATE_DELIVEROO = 'private.dashboard.settings.deliveroo.edit';
export const EP_STORES_GET_JAHEZ_STORE = 'private.dashboard.stores.jahez.getById';
export const EP_STORES_UPDATE_JAHEZ_STORE = 'private.dashboard.stores.jahez.update';

export const EP_ORDERS_LIST = 'private.dashboard.orders.list';
export const EP_ORDERS_GET_BY_ID = 'private.dashboard.orders.getById';
export const EP_ORDERS_TODAY_LIST = 'private.dashboard.orders.today.list';
export const EP_ORDERS_HISTORY_LIST = 'private.dashboard.orders.history.list';
export const EP_ORDERS_HISTORY_EXPORT = 'private.dashboard.orders.history.export';
export const EP_ORDERS_REVIEWS_LIST = 'private.dashboard.orders.reviews';
export const EP_ORDER_ADDRESS_GET_BY_NAME = 'private.dashboard.orders.address.getByName';
export const EP_ORDER_ADDRESS_UPDATE = 'private.dashboard.orders.address.update';
export const EP_ORDER_RECEIPT = 'private.dashboard.orders.printReceipt';
export const EP_ORDER_PARTNER_RECEIPT = 'private.dashboard.orders.partners.printReceipt';
export const EP_ORDERS_MARK_AS_CANCELED = 'private.dashboard.orders.markAsCanceled';
export const EP_ORDERS_EXCLUDE_FROM_BATCHING = 'private.dashboard.orders.excludeFromBatching';
export const EP_ORDERS_ANALYTICS = 'private.dashboard.orders.analytics';
export const EP_ORDERS_PARTNERS_LIST = 'private.dashboard.orders.partners.list';

export const EP_EMPLOYEES_LIST = 'private.dashboard.employees.list';
export const EP_EMPLOYEES_CREATE = 'private.dashboard.employees.create';
export const EP_EMPLOYEES_EDIT = 'private.dashboard.employees.update';

export const EP_EMPLOYEES_GET_BY_ID = 'private.dashboard.employees.getById';

export const EP_BATCHING_CREATE = 'private.dashboard.deliveries.batch.create';
export const EP_BATCHING_PREVIEW = 'private.dashboard.deliveries.batch.preview';
export const EP_BATCHING_SPLIT = 'private.dashboard.deliveries.batch.split';
export const EP_DELIVERIES_COMPLETE = 'private.dashboard.deliveries.complete';
export const EP_DELIVERIES_PENDING_LIST = 'private.dashboard.deliveries.pending.list';

export const EP_PAYMENT_SETTINGS_SET = 'private.dashboard.settings.payments.save';
export const EP_PAYMENT_SETTINGS_GET = 'private.dashboard.settings.payments.get';

export const EP_REPORTS_CASH_GET = 'private.dashboard.reports.cashreport.get';
export const EP_REPORTS_HERO_SKU_AVAILABILITY = 'private.dashboard.reports.heroSkuAvailability';
export const EP_REPORTS_BASKET_DROP_OFF = 'private.dashboard.reports.basketDropOff';
export const EP_REPORTS_SEARCH_TO_ZERO = 'private.dashboard.reports.searchToZero';
export const EP_REPORTS_APP_USAGE = 'private.dashboard.reports.appUsage';

export const EP_LOYALTY_LIST = 'private.dashboard.loyaltyPrograms.list';
export const EP_LOYALTY_GET_BY_ID = 'private.dashboard.loyaltyPrograms.getById';
export const EP_LOYALTY_CREATE = 'private.dashboard.loyaltyPrograms.create';
export const EP_LOYALTY_UPDATE = 'private.dashboard.loyaltyPrograms.update';
export const EP_LOYALTY_LAUNCH_SEGMENTATION = 'private.dashboard.loyaltyPrograms.launchCustomerSegmentation';

export const PRODUCT_SEARCH = 'products.search';

export const EP_DASHBOARD_SEARCH = 'private.dashboard.search';

export const EP_PARTNER_TRACKING_LIST = 'private.dashboard.products.partnertrackings.list';
export const EP_PARTNER_TRACKING_HISTORY = 'private.dashboard.products.partnertrackings.history';

export const EP_PRODUCT_LIST = 'private.dashboard.products.list';
export const EP_PRODUCT_EXPORT = 'private.dashboard.products.export';
export const EP_PRODUCT_DETAIL = 'private.dashboard.products.details';
export const EP_PRODUCT_PARTNER_PRODUCTS = 'private.dashboard.products.partnerproducts';
export const EP_PRODUCT_PARTNER_PRODUCTS_UPDATE = 'private.dashboard.products.partnerproducts.update';
export const EP_PRODUCT_PARTNER_PRODUCTS_UPLOAD = 'private.dashboard.products.partnerproducts.upload';
export const EP_PRODUCT_ARABIC_TITLE_UPDATE = 'private.dashboard.products.arabicTitle.update';
export const EP_PRODUCT_ARABIC_TRANSLATIONS_UPLOAD = 'private.dashboard.products.arabicTranslations.upload';

export const EP_CUSTOMERSEGMENTS_LIST = 'private.dashboard.customerSegments.list';
export const EP_CUSTOMERSEGMENTS_EVALUATE = 'private.dashboard.customerSegments.evaluate';
export const EP_CUSTOMERSEGMENTS_CREATE = 'private.dashboard.customerSegments.create';
export const EP_CUSTOMERSEGMENTS_DELETE = 'private.dashboard.customerSegments.delete';
export const EP_CUSTOMERSEGMENTS_DETAILS = 'private.dashboard.customerSegments.details';
export const EP_CUSTOMERSEGMENTS_EDIT = 'private.dashboard.customerSegments.edit';
export const EP_CUSTOMERSEGMENTS_LIST_CUSTOMERS = 'private.dashboard.customerSegments.listCustomers';
export const EP_CUSTOMERSEGMENTS_LIST_BY_CUSTOMER = 'private.dashboard.customerSegments.listByCustomer';
export const EP_CUSTOMERSEGMENTS_ADD_CUSTOMER = 'private.dashboard.customerSegments.addCustomer';
export const EP_CUSTOMERSEGMENTS_REMOVE_CUSTOMER = 'private.dashboard.customerSegments.removeCustomer';
export const EP_CUSTOMERSEGMENTS_UPLOAD_CSV = 'private.dashboard.customerSegments.uploadCsv';

export const EP_SPOTLIGHT_ITEMS_LIST = 'private.dashboard.spotlightItems.list';
export const EP_SPOTLIGHT_ITEMS_DETAILS = 'private.dashboard.spotlightItems.details';
export const EP_SPOTLIGHT_ITEMS_SAVE = 'private.dashboard.spotlightItems.save';
export const EP_SPOTLIGHT_ITEMS_ADD = 'private.dashboard.spotlightItems.products.add';
export const EP_SPOTLIGHT_ITEMS_REMOVE = 'private.dashboard.spotlightItems.products.remove';
export const EP_SPOTLIGHT_ITEMS_SORT = 'private.dashboard.spotlightItems.products.sort';

export const EP_TOOLS_TALABAT_CATALOGUE_GENERATE = 'private.dashboard.tools.talabatCatalogue.generate';

export const EP_DELIVERY_CHALLENGES_LIST = 'private.dashboard.deliveryChallenges.list';
export const EP_DELIVERY_CHALLENGES_GET_BY_ID = 'private.dashboard.deliveryChallenges.getById';
export const EP_DELIVERY_CHALLENGES_SAVE = 'private.dashboard.deliveryChallenges.save';
export const EP_DELIVERY_CHALLENGES_UPDATE_REWARD = 'private.dashboard.deliveryChallenges.updateReward';
export const EP_DELIVERY_CHALLENGES_UPDATE_CUSTOMER_SEGMENT = 'private.dashboard.deliveryChallenges.updateCustomerSegment';
export const EP_DELIVERY_CHALLENGES_UPDATE_STATUS = 'private.dashboard.deliveryChallenges.updateStatus';
export const EP_DELIVERY_CHALLENGES_SAVE_SCHEDULE = 'private.dashboard.deliveryChallenges.saveSchedule';
export const EP_DELIVERY_CHALLENGES_DELETE_SCHEDULES = 'private.dashboard.deliveryChallenges.deleteSchedules';
export const EP_DELIVERY_CHALLENGES_LIST_NOTIFICATIONS = 'private.dashboard.deliveryChallenges.listNotifications';
export const EP_DELIVERY_CHALLENGES_SAVE_TEMPLATE = 'private.dashboard.deliveryChallenges.saveTemplate';
export const EP_DELIVERY_CHALLENGES_UPLOAD_IMAGE = 'private.dashboard.deliveryChallenges.uploadImage';

export const EP_ANALYTICS_CASH_REPORT = 'GetCashReportFunction';
export const EP_ANALYTICS_HERO_SKU_AVAILABILITY = 'GetHeroSkuAvailabilityFunction';
export const EP_ANALYTICS_BASKET_DROP_OFF = 'GetBasketDropOffFunction';
export const EP_ANALYTICS_SEARCH_TO_ZERO = 'GetSearchToZeroFunction';
export const EP_ANALYTICS_PERFORMANCE_REPORT = 'GetPerformanceReportFunction';
export const EP_ANALYTICS_PERFORMANCE_REPORT_CHARTS = 'GetPerformanceReportChartsFunction';
export const EP_ANALYTICS_PERFORMANCE_TREND = 'GetPerformanceTrendFunction';
export const EP_ANALYTICS_PERFORMANCE_REPORT_EXPORT = 'ExportPerformanceReportFunction';
export const EP_ANALYTICS_ORDER_HISTORY_EXPORT = 'OrderHistoryExportFunction';
export const EP_ANALYTICS_PRODUCT_EXPORT = 'DashboardProductExportFunction';
export const EP_ANALYTICS_NOTIFICATION_ERROR_CUSTOMERS_EXPORT = 'DashboardDownloadErrorCustomersFunction';
export const EP_ANALYTICS_ORDER_ANALYTICS = 'GetOrderAnalyticsFunction';
export const EP_ANALYTICS_DELIVERY_CHALLENGE = 'GetDeliveryChallengeAnalyticsFunction';
export const EP_ANALYTICS_APP_USAGE = 'GetAppUsageFunction';
